import classes from "../homePageNew.module.css";

// Backend sends one insight per metric (visibility, sentiment, brand
// pillars/product dimension, purchase criteria), each already phrased and
// toned — this renders them as-is, no client-side derivation.
// tone: "positive" → green, "negative" → red, anything else → amber.
function dotClass(tone) {
  if (tone === "positive") return classes.alertDotPositive;
  if (tone === "negative") return classes.alertDotNegative;
  return classes.alertDotNeutral;
}

/**
 * Generic "Key Insights" panel — takes a plain `insights` array of
 * { text, tone, metric } straight from the record's own metrics entry (see
 * homePageApi.js's resolveMetrics), so any module's detail view can reuse it
 * with its own insights.
 *
 * NOTE: the CSS class names are still the original `alerts*` ones — they're
 * internal, shared with AttributePanel's dots, and renaming them would touch
 * unrelated components for no visible benefit.
 */
export default function KeyInsightsPanel({ insights }) {
  const items = Array.isArray(insights) ? insights : [];

  return (
    <div className={classes.alertsPanel}>
      <div className={classes.alertsPanelTitle}>Key Insights</div>
      {items.length === 0 ? (
        <div className={classes.mdEmptyList}>No insights available for this run yet.</div>
      ) : (
        <div className={classes.alertsList}>
          {items.map((insight, idx) => (
            <div className={classes.alertItem} key={insight.metric || idx}>
              <span className={`${classes.alertDot} ${dotClass(insight.tone)}`} />
              <span className={classes.alertText}>{insight.text}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
